import { lazy } from 'react';

const ExecutionRunsPage = lazy(async () => {
  const module = await import('@/features/executionRuns/pages/ExecutionRunsPage');
  return { default: module.ExecutionRunsPage };
});

const FeaturesPage = lazy(async () => {
  const module = await import('@/features/features/routes');
  return { default: module.FeaturesPage };
});

const JobsPage = lazy(async () => {
  const module = await import('@/features/jobs/routes');
  return { default: module.JobsPage };
});

const PipelinesPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/PipelinesPage');
  return { default: module.PipelinesPage };
});

const StagesPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/StagesPage');
  return { default: module.StagesPage };
});

const ReleasesPage = lazy(async () => {
  const module = await import('@/features/releases/routes');
  return { default: module.ReleasesPage };
});

const SuitesPage = lazy(async () => {
  const module = await import('@/features/suites/routes');
  return { default: module.SuitesPage };
});

const TestsPage = lazy(async () => {
  const module = await import('@/features/tests/routes');
  return { default: module.TestsPage };
});

const LandingPage = lazy(async () => {
  const module = await import('../../pages/LandingPage');
  return { default: module.LandingPage };
});

const PreviewPage = lazy(async () => {
  const module = await import('../../pages/PreviewPage');
  return { default: module.PreviewPage };
});

const PlanPage = lazy(async () => {
  const module = await import('../../pages/PlanPage');
  return { default: module.PlanPage };
});

const PrivacyRequestsPage = lazy(async () => {
  const module = await import('../../pages/PrivacyRequestsPage');
  return { default: module.PrivacyRequestsPage };
});

const ProjectSettingsPage = lazy(async () => {
  const module = await import('@/features/projects/pages/ProjectSettingsPage');
  return { default: module.ProjectSettingsPage };
});

const ProjectSettingsSlugRedirect = lazy(async () => {
  const module = await import('@/features/projects/pages/ProjectSettingsSlugRedirect');
  return { default: module.ProjectSettingsSlugRedirect };
});

const PocketPhrasebookPrivacyPage = lazy(async () => {
  const module = await import('../../pages/PocketPhrasebookPrivacyPage');
  return { default: module.PocketPhrasebookPrivacyPage };
});

const PocketPhrasebookSupportPage = lazy(async () => {
  const module = await import('../../pages/PocketPhrasebookSupportPage');
  return { default: module.PocketPhrasebookSupportPage };
});

const ReportsPage = lazy(async () => {
  const module = await import('../../pages/ReportsPage');
  return { default: module.ReportsPage };
});

const TrendsPage = lazy(async () => {
  const module = await import('@/features/trends/TrendsPage');
  return { default: module.TrendsPage };
});

const ReportDetailPage = lazy(async () => {
  const module = await import('../../pages/ReportDetailPage');
  return { default: module.ReportDetailPage };
});

const ResetPasswordConfirmPage = lazy(async () => {
  const module = await import('../../pages/ResetPasswordConfirmPage');
  return { default: module.ResetPasswordConfirmPage };
});

const ResetPasswordPage = lazy(async () => {
  const module = await import('../../pages/ResetPasswordPage');
  return { default: module.ResetPasswordPage };
});

const SessionExpired = lazy(async () => {
  const module = await import('../../pages/SessionExpired');
  return { default: module.SessionExpired };
});

const SuperuserPage = lazy(async () => {
  const module = await import('../../pages/SuperuserPage');
  return { default: module.SuperuserPage };
});

const UserSettingsPage = lazy(async () => {
  const module = await import('../../pages/UserSettingsPage');
  return { default: module.UserSettingsPage };
});

const VerifyEmailPage = lazy(async () => {
  const module = await import('../../pages/VerifyEmailPage');
  return { default: module.VerifyEmailPage };
});

const AuthDebugIndexPage = lazy(async () => {
  const module = await import('@/features/authDebug/pages/AuthDebugIndexPage');
  return { default: module.AuthDebugIndexPage };
});

const AuthDebugScreenPage = lazy(async () => {
  const module = await import('@/features/authDebug/pages/AuthDebugScreenPage');
  return { default: module.AuthDebugScreenPage };
});

const BuildDetailPage = lazy(async () => {
  const module = await import('@/features/builds/routes');
  return { default: module.BuildDetailPage };
});

const JobRunDetailPage = lazy(async () => {
  const module = await import('@/features/builds/routes');
  return { default: module.JobRunDetailPage };
});

const ExecutionRunDetailPage = lazy(async () => {
  const module = await import('@/features/executionRuns/pages/ExecutionRunDetailPage');
  return { default: module.ExecutionRunDetailPage };
});

const FeatureDetailPage = lazy(async () => {
  const module = await import('@/features/features/routes');
  return { default: module.FeatureDetailPage };
});

const OnboardingPage = lazy(async () => {
  const module = await import('@/features/onboarding/pages/OnboardingPage');
  return { default: module.OnboardingPage };
});

const OnboardingDebugIndexPage = lazy(async () => {
  const module = await import('@/features/onboardingDebug/pages/OnboardingDebugIndexPage');
  return { default: module.OnboardingDebugIndexPage };
});

const OnboardingDebugScreenPage = lazy(async () => {
  const module = await import('@/features/onboardingDebug/pages/OnboardingDebugScreenPage');
  return { default: module.OnboardingDebugScreenPage };
});

const DialogVisualDebugPage = lazy(async () => {
  const module = await import('@/features/dialogVisualDebug/pages/DialogVisualDebugPage');
  return { default: module.DialogVisualDebugPage };
});

const StatePanelVisualDebugPage = lazy(async () => {
  const module = await import('@/features/statePanelVisualDebug/pages/StatePanelVisualDebugPage');
  return { default: module.StatePanelVisualDebugPage };
});

const PageScaffoldVisualDebugPage = lazy(async () => {
  const module =
    await import('@/features/pageScaffoldVisualDebug/pages/PageScaffoldVisualDebugPage');
  return { default: module.PageScaffoldVisualDebugPage };
});

const OrganisationSettingsPage = lazy(async () => {
  const module = await import('@/features/organisations/pages/OrganisationSettingsPage');
  return { default: module.OrganisationSettingsPage };
});

const ProjectDetailPage = lazy(async () => {
  const module = await import('@/features/projects/routes');
  return { default: module.ProjectDetailPage };
});

const PipelineDetailPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/PipelineDetailPage');
  return { default: module.PipelineDetailPage };
});

const StageDetailPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/StageDetailPage');
  return { default: module.StageDetailPage };
});

const StageExecutionDetailPage = lazy(async () => {
  const module = await import('@/features/pipelines/pages/StageExecutionDetailPage');
  return { default: module.StageExecutionDetailPage };
});

const JobDetailPage = lazy(async () => {
  const module = await import('@/features/jobs/routes');
  return { default: module.JobDetailPage };
});

const ReleaseDetailPage = lazy(async () => {
  const module = await import('@/features/releases/routes');
  return { default: module.ReleaseDetailPage };
});

const SignInPage = lazy(async () => {
  const module = await import('../../pages/SignInPage');
  return { default: module.SignInPage };
});

const SignUpPage = lazy(async () => {
  const module = await import('../../pages/SignUpPage');
  return { default: module.SignUpPage };
});

const AuthCallbackPage = lazy(async () => {
  const module = await import('../../pages/AuthCallbackPage');
  return { default: module.AuthCallbackPage };
});

const AcceptInvitationPage = lazy(async () => {
  const module = await import('../../pages/AcceptInvitationPage');
  return { default: module.AcceptInvitationPage };
});

const SuiteDetailPage = lazy(async () => {
  const module = await import('@/features/suites/routes');
  return { default: module.SuiteDetailPage };
});

const SuiteRunDetailPage = lazy(async () => {
  const module = await import('@/features/executions/routes');
  return { default: module.SuiteRunDetailPage };
});

const TestDetailPage = lazy(async () => {
  const module = await import('@/features/tests/routes');
  return { default: module.TestDetailPage };
});

const TestRunDetailPage = lazy(async () => {
  const module = await import('@/features/executions/routes');
  return { default: module.TestRunDetailPage };
});

const ResultsFileDetailPage = lazy(async () => {
  const module = await import('@/features/uploads/routes');
  return { default: module.ResultsFileDetailPage };
});

const UploadsPage = lazy(async () => {
  const module = await import('@/features/uploads/routes');
  return { default: module.UploadsPage };
});

const UploadDetailPage = lazy(async () => {
  const module = await import('@/features/uploads/routes');
  return { default: module.UploadDetailPage };
});

export {
  AcceptInvitationPage,
  AuthDebugIndexPage,
  AuthDebugScreenPage,
  AuthCallbackPage,
  BuildDetailPage,
  DialogVisualDebugPage,
  ExecutionRunDetailPage,
  ExecutionRunsPage,
  FeatureDetailPage,
  FeaturesPage,
  JobDetailPage,
  JobRunDetailPage,
  JobsPage,
  LandingPage,
  OnboardingDebugIndexPage,
  OnboardingDebugScreenPage,
  OnboardingPage,
  OrganisationSettingsPage,
  PageScaffoldVisualDebugPage,
  ProjectDetailPage,
  ProjectSettingsPage,
  ProjectSettingsSlugRedirect,
  PipelineDetailPage,
  PipelinesPage,
  PlanPage,
  PocketPhrasebookPrivacyPage,
  PocketPhrasebookSupportPage,
  PreviewPage,
  PrivacyRequestsPage,
  ReleaseDetailPage,
  ReleasesPage,
  ReportsPage,
  ReportDetailPage,
  ResetPasswordConfirmPage,
  ResetPasswordPage,
  ResultsFileDetailPage,
  SessionExpired,
  SignInPage,
  SignUpPage,
  StageDetailPage,
  StageExecutionDetailPage,
  StatePanelVisualDebugPage,
  StagesPage,
  SuiteDetailPage,
  SuiteRunDetailPage,
  SuitesPage,
  SuperuserPage,
  TestDetailPage,
  TestRunDetailPage,
  TestsPage,
  TrendsPage,
  UploadsPage,
  UploadDetailPage,
  UserSettingsPage,
  VerifyEmailPage,
};
